import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { TranslateService } from '@ngx-translate/core';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

@Component({
  templateUrl: 'register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit, AfterViewInit {
  registerForm: FormGroup;
  loading = false;
  submitted = false;
  errorMessage = '';
  successMessage = '';
  defaultImage = '../assets/images/portrait/small/default.png';
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private alertService: AlertService,
    private authService: AuthService,
    private renderer: Renderer2,
    private translate: TranslateService) {
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });

    this.renderer.addClass(document.body, 'authentication-pages');
  }

  ngAfterViewInit(): void {
    const footerElement = document.getElementsByClassName('footer');
    Array.from(footerElement).forEach((el) => {
      this.renderer.removeClass(el, 'footer-static');
      this.renderer.addClass(el, 'fixed-bottom');
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  tryRegister() {
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    this.loading = true;


    this.authService.doRegister(this.registerForm.value).then(
      res => {

        this.loading = false;
        console.log(res);
        this.errorMessage = '';
        this.alertService.success(this.translate.instant('register.successMessage'), true);
        
        this.router.navigate(['/register/validation']);
      },
      err => {
        console.log(err);
        this.loading = false;
        if(err.status==400 && err.error.message.includes("is already taken"))
          this.alertService.error(err.error.message);
        else
          this.alertService.error(err.message);
      }
    );
  }
}
